export default __webpack_public_path__ + "static/media/pngegg.70e7f70b.png";